import { atom } from "jotai";

import { currentModalStepAtom } from "../../stores";

export const enterEditableRoundsPrivateStepAtom = atom(
  null,
  (get, set, payload?: null) => {
    set(currentModalStepAtom, { type: "EditRoundsPrivate" });
  }
);
